// extracted by mini-css-extract-plugin
export default {"mapContainer":"PatchesMap_mapContainer__Fr6GO","map":"PatchesMap_map__-K18H"};